import Index from '../components/PromotionalOrder/Index';

let routes = {
    path: '/promotionalOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/promotionalOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/promotionalOrder.js